import { Links, Meta, Scripts } from '@remix-run/react';
import { Footer } from '~/components/footer';
import { Navbar } from '~/components/navbar';

export type ErrorPageLayoutProps = {
  children: React.ReactNode;
};

export const ErrorPageLayout = ({ children }: ErrorPageLayoutProps) => {
  return (
    <html>
      <head>
        <title>Oops, something went wrong | Findigs</title>
        <Meta />
        <Links />
      </head>
      <body>
        <div id="app">
          <Navbar loaderData={null} />
          <main className="text-center pt-12 pb-12">{children}</main>
          <Footer />
        </div>
        <Scripts />
      </body>
    </html>
  );
};
